import AntdDivider     from 'antd/lib/divider';
import { DividerProps } from 'antd/lib/divider';

export default function Divider(props: DividerProps) {
	return <AntdDivider {...props} />;
}